import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_2: FaireProductEntity = {
  token: "atc_updated_fs_rec_2",
  type: "product",
  name: "Colorful Checkered Throw Blanket",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/75628444ed9ef5317b703ef79349e828071a38d8fa971ab0b574c86a8ca47d55.webp",
  priceDollars: 38,
  msrpDollars: 76,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
